var _defs, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingDecorLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1920v1080H0V0z",
    id: "pricing-decor-left_svg__a"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "pricing-decor-left_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pricing-decor-left_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    clipPath: "url(#pricing-decor-left_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf10",
    d: "M46.153 102.792c3.848.55 4.748-3.749 15.493-10.995 26.838-18.042 46.679-5.548 61.472-17.992 2.299-1.95 4.198-3.998 5.897-6.997 17.192.5 40.532-7.147 56.574-15.993 31.036-17.142 62.722-54.275 52.476-75.465-8.446-17.492-43.68-20.64-68.468-12.494-10.695 3.498-20.391 9.445-28.837 16.742.1-1.7.2-3.448.35-5.248 3.348-53.525 6.747-62.87-1.5-72.966-15.792-19.341-54.475-22.64-78.963-8.496C-5.023-69.13 22.964 99.343 46.153 102.792z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    stroke: "null",
    transform: "translate(-158.838 -15.104) scale(.49977)",
    y2: 0.5,
    x2: 1.042,
    y1: 0.5,
    x1: -1.526,
    id: "pricing-decor-left_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00f260",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0575e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pricing-decor-left_svg__c)",
    d: "M-84.287-18.153C-76.19-.561-51.702-6.308-44.805 10.834c13.594 33.734-43.23 87.46-34.984 94.956 1 .95 1.9.1 13.494-1.5 10.295-1.398 18.641-2.548 25.488-1.998 10.895.9 15.043 5.897 24.989 10.495 16.642 7.646 35.583 7.746 45.979 4.998C55.449 111.138 50 80.752 76.639 58.812c40.032-33.035 85.011-8.746 104.452-35.984 15.743-22.09 1.45-61.572-14.493-83.961C118.42-128.703-11.67-132.95-62.297-79.625c-13.394 14.094-30.786 42.33-21.99 61.472z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingDecorLeft);
export default __webpack_public_path__ + "static/media/pricing-decor-left.88ef9e18767b66ffa46d075f46dc98e2.svg";
export { ForwardRef as ReactComponent };